/**
 * 消息中心API
 */
import http from './http'

class MessageApi {
    // 获取消息分类
    static getClassify() {
        return http.httpGet('message/classify');
    }
    // 获取未读消息数量
    static getNewTotal() {
        return http.httpGet('message/newTotal');
    }
    // 更新消息
    static updateMessage() {
        return http.httpPost('message/update');
    }
    // 获取消息列表
    static getList(params) {
        return http.httpGet('message/list', params);
    }
    // 获取消息详细
    static getItem(id) {
        return http.httpGet('message', {id});
    }
    // 删除消息
    static delMessage(params) {
        return http.httpPost('message/delMessage', params);
    }
    // 标记已读
    static readMessage(params) {
        return http.httpPost('message/readMessage', params);
    }
}

export default MessageApi;



// WEBPACK FOOTER //
// ./app/api/message.api.js